// 투표 제어를 위한 유틸리티 함수들

export const VOTE_STORAGE_KEY = 'squad_vote_completed';

/**
 * 디바이스 고유 식별자 생성 (브라우저 기반)
 */
export const getDeviceId = (): string => {
  // 브라우저 정보와 화면 해상도를 조합한 고유 식별자 생성
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device fingerprint', 2, 2);
  }
  
  const fingerprint = [
    navigator.userAgent,
    navigator.language,
    window.screen.width + 'x' + window.screen.height,
    new Date().getTimezoneOffset(),
    canvas.toDataURL()
  ].join('|');
  
  // 간단한 해시 생성
  let hash = 0;
  for (let i = 0; i < fingerprint.length; i++) {
    const char = fingerprint.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // 32bit 정수로 변환
  }
  
  return Math.abs(hash).toString(36);
};

/**
 * 투표 완료 여부 확인
 */
export const hasVoted = (): boolean => {
  const deviceId = getDeviceId();
  const storedData = localStorage.getItem(VOTE_STORAGE_KEY);
  
  if (!storedData) return false;
  
  try {
    const { deviceId: storedDeviceId, timestamp } = JSON.parse(storedData);
    return storedDeviceId === deviceId;
  } catch {
    return false;
  }
};

/**
 * 투표 완료 상태 저장
 */
export const markAsVoted = (): void => {
  const deviceId = getDeviceId();
  const voteData = {
    deviceId,
    timestamp: new Date().toISOString()
  };
  
  localStorage.setItem(VOTE_STORAGE_KEY, JSON.stringify(voteData));
};

/**
 * 투표 상태 초기화 (관리자용)
 */
export const resetVoteStatus = (): void => {
  localStorage.removeItem(VOTE_STORAGE_KEY);
};
